module.exports = __webpack_public_path__ + "img/5.02.thmb.xs.938e9a92.jpg";